import { BaseSdk } from '../../base.sdk';
import {
    ICreateProspectData,
    PreviewProspectDetailsDto,
    ValidatedName,
    BulkImportValidationResponseDto,
    PersonFilterDto,
    PreviewProspectingDtos,
} from '@zaplify/prospects';
import { ProspectSearchAutoCompleteFields } from '@zaplify/prospects';
import { ExpandCompanyRequestDto } from '@zaplify/prospects';
import { ProspectSearchFiltersDto } from '@zaplify/prospects';
import { LocationDto } from '@zaplify/prospects';
import { CompaniesDto } from '@zaplify/prospects';
import { ValidateBulkImportDto } from '@zaplify/prospects';

export class SourcesSdk extends BaseSdk {
    async previewProspects(prospectSearchFilter: ProspectSearchFiltersDto) {
        return this.post<{ hits: number }>({
            path: `${this.sourcesPath}/prospect-search/preview-prospecting`,
            payload: prospectSearchFilter,
        });
    }

    async getPersonFilter(filterId: string) {
        return this.get<PersonFilterDto>(`${this.sourcesPath}/${filterId}`);
    }

    async createFilter(filters: ProspectSearchFiltersDto) {
        return this.post<PersonFilterDto>({
            path: `${this.sourcesPath}/prospect-search`,
            payload: filters,
        });
    }

    async deleteSource(sourceId: string) {
        return this.delete<void>(`${this.sourcesPath}/${sourceId}`);
    }

    // async startProspecting(sourceId: string) {
    //     return this.post<SourceDto>({ path: `${this.sourcesPath}/${sourceId}/prospect-search/run` });
    // }

    async assignProspectsToSegment(sourceId: string, prospectIds: string[]) {
        return this.post<void>({ path: `${this.sourcesPath}/${sourceId}/prospects`, payload: prospectIds });
    }

    async autocomplete(input: { field: ProspectSearchAutoCompleteFields; query: string }) {
        return this.get<CompaniesDto[] | LocationDto[]>(
            `${this.sourcesPath}/prospect-search/autocomplete?field=${input.field}&query=${input.query}`,
        );
    }

    async validateNames(names: string[]) {
        return this.post<ValidatedName[]>({
            path: `${this.sourcesPath}/prospect-search/validate-companies`,
            payload: names,
        });
    }

    async updateSource(filterId: string, filters: Partial<ProspectSearchFiltersDto>) {
        return this.patch<PersonFilterDto>(`${this.sourcesPath}/${filterId}`, filters);
    }

    // async removeProspectsFromSource(sourceId: string, prospectIds: string[]) {
    //     return this.post<any>({ path: `${this.sourcesPath}/${sourceId}/prospects/delete`, payload: prospectIds });
    // }

    async suggestTitles(field: string, query: string[]) {
        return this.get<string[]>(
            `${this.sourcesPath}/prospect-search/suggest?field=${field}&query=${encodeURIComponent(
                JSON.stringify(query),
            )}`,
        );
    }

    // async createBulkImport(createBulkImportDto: CreateBulkImportDto) {
    //     return this.post<any>({ path: `${this.sourcesPath}/bulk-import`, payload: createBulkImportDto });
    // }

    async validateBulkImport(validateBulkImport: ValidateBulkImportDto): Promise<BulkImportValidationResponseDto> {
        return this.post<any>({ path: `${this.sourcesPath}/validate-bulk-import`, payload: validateBulkImport });
    }

    async runBulkImport(createProspectDataDto: ICreateProspectData[], campaignId: string) {
        return this.post<any>({
            path: `${this.sourcesPath}/bulk-import/run?campaignId=${campaignId}`,
            payload: createProspectDataDto,
        });
    }

    async previewProspectingList(prospectSearchFilter: ProspectSearchFiltersDto, feed: boolean, campaignId?: string) {
        return this.post<PreviewProspectingDtos.ResponsePerPerson>({
            path: `${this.sourcesPath}/prospect-search/preview-prospecting/list-view${
                feed ? `?feed=${feed}${campaignId ? `&campaignId=${campaignId}` : ''}` : ''
            }`,
            payload: prospectSearchFilter,
        });
    }

    async expandMoreProspectPerCompany(expandCompany: ExpandCompanyRequestDto): Promise<PreviewProspectDetailsDto[]> {
        return this.post({
            path: `${this.sourcesPath}/prospect-search/preview-prospecting/expand`,
            payload: expandCompany,
        });
    }

    async previewProspectingDetails(body: { personId: string }) {
        return this.post<PreviewProspectDetailsDto>({
            path: `${this.sourcesPath}/prospect-search/preview-prospecting/details`,
            payload: body,
        });
    }

    async purchaseToCampaign(
        input: { personIds: string[]; linkedinUrls: string[] },
        campaignId?: string,
        groupId?: string,
    ) {
        const campaignIdString = campaignId ? `campaignId=${campaignId}` : '';
        const groupIdString = groupId ? `groupId=${groupId}` : '';
        return this.post<string[]>({
            path: `${this.sourcesPath}/purchase-persons?${campaignIdString}${groupIdString}`,
            payload: input,
        });
    }
}
